const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-435 -1032)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD0C0\\uC6D0 110",
    transform: "translate(435 1032)",
    style: {
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 138",
    transform: "translate(444 1037)",
    style: {
      strokeLinecap: "round",
      stroke: "#fff",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0v4"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 111",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(443 1044)",
    style: {
      fill: "#fff"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.d2f18444d723cbb9e4b0f5aa1abc491a.svg";
export { ForwardRef as ReactComponent };